import { CustomerCategory } from 'components/customer/api/CustomerAPI';

export interface GetCustomersV2Dto {
  crmCustomerId: number;
  name: string;
  organizationName: string;
  phoneNumber: string;
  isPhoneNumberVerified: boolean | null;
  emailAddress: string;
  address: string;
  dmsSync: boolean;
  isFacebookCustomer: boolean;
  isInstagramCustomer: boolean;
}
export interface GetCustomersV2Response {
  customers: GetCustomersV2Dto[];
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
}
export interface GetCustomersV2Request {
  pageNumber: number;
  pageSize: number;
  searchString: string;
}

export interface CustomerPhone {
  id: number;
  customer?: null;
  customerId: number;
  dealerId: number;
  lastUpdated: string;
  phoneNumber: string;
  extension: string;
  phoneType: number;
  contactId: number;
  isPrimary: boolean;
  isDefault:boolean;
  verificationStatus: number | null;
}
export interface CustomerEmail {
  contactId: number;
  address: string;
  customer?: null;
  customerId: number;
  dealerId: number;
  emailType: number;
  lastUpdated: string;
  isPrimary: boolean;
  isDefault:boolean;
}

export interface CustomerAddress {
  address1: string;
  address2: string;
  city: string;
  stateProvince: string;
  zipPostal: string;
  addressType: string;
  stateShort: string;
  county: string;
  isBillingNShipping:boolean;
}

export interface CustomerDto {
  id: number;
  dealerId: number;
  name: string;
  cellPhone: string;
  verificationStatus: boolean;
  optIn: number;
  city: string;
  stateProvince: string;
  zipPostal: string;
  createdAt?: string;
}

// new DTO
export interface OwnedUnitDto {
  inventoryWGId: string;
  branch: string;
  branchNumber?: string | null;
  dealerId: number;
  dmsLocationId: number;
  unit: string;
  manufacturerId?: string | null;
  manufacturerCode?: string | null;
  manufacturerName?: string | null;
  model: string;
  modelDescription?: string;
  serialNumber: string;
  price: number;
  unitTotalCost: number;
  make?: string | null;
  year: number;
  hourmeter?: string | null;
  status: string;
  used: boolean;
  receivedDate: string;
  currentOwnerId: number;
  notes?: string | null;
  ownerStatus?: string | null;
  unitStatus?: string | null;
  unitAcquisitionCost: number;
  unitTotalRentalRevenue: number;
  plateNumber?: string | null;
  pinNumber?: string | null;
  repairsPerUnit?: string | null;
  interestPerUnit?: string | null;
  startCostDepreciation: number;
  dateLastPM?: string | null;
  unitDepreciationType?: string | null;
  unitAmountOwedToVendor: number;
  unitOwedVendor?: string | null;
  unitImprovements?: string | null;
  rentalGroup?: string | null;
}


export interface CustomerContactDto {
  crmCustomerId: number;
  customerId: number;
  customerName: string;
  contactId: number;
  contactName: string;
  phoneId: number;
  phoneNumber: string;
  isOrganization: boolean;
  organizationName: string;
  isAspenPrimaryContact: boolean;
}

export interface CustomerTableDto {
  id: number;
  dealerId: number;
  name: string;
  cellPhone: string;
  verificationStatus: boolean;
  optIn: number;
  city: string;
  stateProvince: string;
  zipPostal: string;
  isOrganization?:boolean;
  organizationName?:string;
  emailAddress?:string;
  address?:string;
  customerNumber?: string;
  originationSource?: string;
  uniqueIdentifier?: string;
  createdAt?: any;
  DMSSync?: boolean;
  SocialChannels?: boolean;
}

export interface SocialMediaCustomerDto {
  id: number;
  dealerId: number;
  name: string;
  cellPhone: string;
  organizationName?: string;
  emailAddress?: string;
  originationSource?: string;
  createdAt?: any;
  isFacebookCustomer?: boolean;
  isInstagramCustomer?: boolean;
}

export interface CustomerTags {
  crmCustomerId: number;
  tag: string;
  title: string;
  tagTitleId?: number;
  tagOptionId?: number;
  lastUpdated: string;
}

interface Customer {
  crmCustomerId: number;
  dealerId: number;
  customerId: number;
  salesRepName: string;
  organizationName: string;
  customerAddresses: CustomerAddress[];
  customerPhones: CustomerPhone[];
  customerEmails: CustomerEmail[];
  customerCategories: CustomerCategory[];
  customerTags: CustomerTags[];
  conversationsPhoneIds: number[];
  optIn: number;
  optInEmail: boolean;
  isOrganization: boolean;
  name: string;
  firstName: string;
  middleName : string;
  lastName : string;
  customerNumber : string | number | null;
  jobTitle : string;
  dateOfBirth : Date | null;
  optOutDate: string;
  lastSurveyRating?: number | null;
  lastSurveyRatingDate?: Date | null;
  notes: string;
  primaryCellPhoneId?: number;
  primaryContactId?: number;
  primaryEmailId?:number;
  dob?:string;
  defaultPhoneNumberForMessenger:string;
  defaultPhoneType:number;
  salesStageId?: string | number | null; 
  reviewFlag: boolean;
  IsFacebookCustomer : boolean | null;
  FacebookCustomerId : string | null;
  facebookName : string | null;
  IsInstagramCustomer : boolean | null;
  InstagramCustomerId : string | null;
  instagramName : string | null;
}

export interface CustomerNameObject {
  customerNumber: any;
  contactId: number;
  dateOfBirth: Date | null;
  firstName: string;

  jobTitle: string;
  lastName: string;
  middleName: string;
  name: string;
}

export enum PhoneVerificationStatusEnum {
  Verified = 1,
  Failed = 2,
  Invalid = 3
}

export enum addressTypes {
  Billing = 0,
  Shipping = 1,
}

export interface CustomerTags {
  tag: string;
}

export interface CustomerTag {
  tag: string;
  tagTitleId?: number;
  tagOptionId?: number;
}

export default Customer;
